<!-- Camera -->
<div class="camera-bar">
  <!-- Center camera -->
  <button
    *ngIf="showCenter"
    app-button
    buttonTheme="light"
    (click)="centerCamera()"
    matTooltip="Center model point of view"
    matTooltipPosition="left">
    <fa-icon size="sm" icon="crosshairs"></fa-icon>
  </button>

  <div class="camera-bar__divider" *ngIf="showCenter"></div>

  <!-- Return to chapter position -->
  <button
    app-button
    buttonTheme="light"
    (click)="returnToChapterCamera()"
    matTooltip="Return to starting position"
    matTooltipPosition="left">
    <fa-icon size="sm" icon="location-arrow"></fa-icon>
  </button>

  <!-- Pan -->
  <button 
    app-button
    buttonTheme="light"
    [selected]="(panMode$ | async) === 'pan'"
    (click)="togglePan()"
    matTooltip="Pan"
    matTooltipPosition="left">
    <fa-icon size="sm" icon="arrows-alt"></fa-icon>
  </button>

  <div class="camera-bar__divider"></div>

  <!-- Zoom In -->
  <button
    app-button
    buttonTheme="light"
    #zoomIn
    (touchstart)="setZoom('in')"
    (mousedown)="setZoom('in')"
    (touchend)="setZoom('')"
    (mouseup)="setZoom('')"
    (mouseleave)="setZoom('')"
    matTooltip="Zoom In"
    matTooltipPosition="left">
    <fa-icon size="sm" icon="plus"></fa-icon>
  </button>

  <!-- Zoom Out -->
  <button
    app-button
    buttonTheme="light"
    (touchstart)="setZoom('out')"
    (mousedown)="setZoom('out')"
    (touchend)="setZoom('')"
    (mouseup)="setZoom('')"
    (mouseleave)="setZoom('')"
    matTooltip="Zoom Out"
    matTooltipPosition="left">
    <fa-icon size="sm" icon="minus"></fa-icon>
  </button>
</div>